import clear_all_videos from "@/router/modules/methods/clear_all_videos";

export default {
    path: '/add-entry',
    name: 'Add-Entry',
    component: () => import('@/views/entry/index.vue'),
    meta: {
        title: 'Выбор вступления',
        forVisitors: true
    },
    beforeEnter: async (to, from, next) => {
        await clear_all_videos()
        next()
    }
}